import { Consigne } from "domain/entities/consignes.entities";
import { useFieldArray, UseFormReturn } from "react-hook-form";
import { HiOutlineTrash, HiPlus } from "react-icons/hi";
import { translate } from "ui/i18n";
import { HorizontalDivider } from "ui/pages/app/components/HorizontalDivider";
import { INInput } from "ui/pages/app/components/inputs/INInput";
import { Trans } from "react-i18next";
import { ConsigneInfos } from "./ConsignesInfos";
import { i18nKey } from "domain/entities/activities.entities";
import { INTextarea } from "ui/pages/app/components/inputs/INTextarea";
import { Dispatch, SetStateAction } from "react";
import { INControlledTimeInput } from "ui/pages/app/components/inputs/INTimeInput";

interface IProps {
  consigneForm: UseFormReturn<
    {
      consignes: Consigne[];
    },
    any,
    {
      consignes: Consigne[];
    }
  >;
  setRemovedConsignes: Dispatch<SetStateAction<number[]>>;
}

export function Consignes({ consigneForm, setRemovedConsignes }: IProps) {
  const {
    control,
    register,
    formState: { errors },
  } = consigneForm;
  const { fields, remove, insert } = useFieldArray({
    control,
    name: "consignes",
  });

  const addConsigne = () => {
    insert(fields.length, {
      title: "",
      content: "",
      duration: "",
      order: fields.length,
    });
  };

  const removeConsigne = (index: number) => {
    if (!consigneForm.getValues(`consignes.${index}.isInniz`)) {
      setRemovedConsignes((prev) => [
        ...prev,
        consigneForm.getValues(`consignes.${index}.id`),
      ]);
    }
    remove(index);
  };

  return (
    <div>
      <h3 className="mb-8 flex items-center font-bold">
        {translate("ns1:TechniqueConsignes.ConsigneForParticipants")}
        <ConsigneInfos className="ms-2" />
      </h3>

      {fields.map((field, index) => (
        <div key={field.id}>
          {index > 0 && <HorizontalDivider gap="32px" />}

          <div className="flex items-center justify-between">
            <h4 className="mb-6 flex items-center font-bold">
              <Trans
                i18nKey={"TechniqueConsignes.ConsigneNumber" as i18nKey}
                values={{ number: index + 1 }}
              />
            </h4>
            <button
              className="flex h-10 w-10 items-center justify-center rounded-xl border border-pink-500"
              onClick={() => removeConsigne(index)}
            >
              <HiOutlineTrash size={20} className="text-pink-500" />
            </button>
          </div>
          <INInput
            type="consigneTitle"
            error={errors.consignes?.[index]?.title}
            label={translate("ns1:Input.Labels.Title") + "*"}
            placeholder={translate(
              "ns1:Input.Placeholders.ExempleTechniqueConsigneTitle"
            )}
            className="mb-4 md:mb-6"
            register={{
              ...register(`consignes.${index}.title` as const, {
                required: translate("ns1:Input.Errors.Required"),
              }),
            }}
          />

          <INTextarea
            error={errors.consignes?.[index]?.content}
            label={translate("ns1:Input.Labels.Description") + "*"}
            placeholder={translate(
              "ns1:Input.Placeholders.ExempleTechniqueConsigneDescription"
            )}
            className="mb-4 md:mb-6"
            register={{
              ...register(`consignes.${index}.content` as const, {
                required: translate("ns1:Input.Errors.Required"),
              }),
            }}
          />

          {/* <label className="w-full text-sm font-bold leading-6 text-darkGrey-700">
            {translate("ns1:Input.Labels.Description") + "*"}
            <MDXEditor
              markdown={field.content}
              plugins={[
                headingsPlugin(),
                listsPlugin(),
                toolbarPlugin({
                  toolbarContents: () => (
                    <>
                      <BoldItalicUnderlineToggles />
                      <ListsToggle options={["bullet", "number"]} />
                    </>
                  ),
                }),
              ]}
              onChange={(value) => (field.content = value)}
              className="mb-4 mt-2 rounded-xl border border-darkGrey-500 bg-white p-3 text-sm font-medium text-darkGrey-700 md:mb-6"
              placeholder={translate(
                "ns1:Input.Placeholders.ExempleTechniqueConsigneDescription"
              )}
            />
          </label> */}

          <INControlledTimeInput
            inputName={`consignes.${index}.duration`}
            control={control}
            label={translate("ns1:Input.Labels.Duration") + "*"}
            required
          />
        </div>
      ))}

      <div className="mt-10 flex items-center justify-center text-darkGrey-800">
        <button
          className="me-4 flex items-center space-x-2"
          onClick={addConsigne}
        >
          <HiPlus size={20} />
          <span className="text-sm font-bold">
            {translate("ns1:TechniqueConsignes.AddConsigne")}
          </span>
        </button>
      </div>
    </div>
  );
}
